import axios from './axios';

class Analysis {

    getMetaData = async (operator) => {
        const response = await axios.get(`Analysis/MetaData?operatorId=${operator}`);
        return response.data;
    }

    getGrid = async (
        fromDate, 
        toDate, 
        dataType, 
        totalBy, 
        timeGroupById, 
        dataGroupId, 
        categoryIds,
        operatorId,
        companyId, 
        subCompanyId, 
        siteId,
        daysOfWeek
    ) => {
        const response = await axios.post(`Analysis/Grid`, {
            fromDate,
            toDate,
            dataType,
            totalBy,
            timeGroupById,
            dataGroupId,
            categoryIds,
            operatorId,
            companyId: companyId || -1, 
            subCompanyId: subCompanyId || -1,
            siteId: siteId || -1,
            daysOfWeek
        });
        return response.data;
    }

    getGraph = async (
        selectedRows,
        fromDate, 
        toDate, 
        dataType, 
        totalBy, 
        timeGroupById, 
        dataGroupId, 
        categoryIds,
        operatorId,
        companyId, 
        subCompanyId, 
        siteId,
        daysOfWeek
    ) => {

        const response = await axios.post(`Analysis/Graph`, {
            rowKeys: selectedRows.map(row => row.key),
            category: selectedRows.length > 1 ? null : selectedRows[0].category,
            fromDate,
            toDate,
            dataType,
            totalBy,
            timeGroupById,
            dataGroupId,
            categoryIds,
            operatorId,
            companyId: companyId || -1, 
            subCompanyId: subCompanyId || -1,
            siteId: siteId || -1,
            daysOfWeek
        });
        return response.data;
    }

    getExport = async (
        emailAddress,
        fromDate, 
        toDate, 
        dataType, 
        totalBy, 
        timeGroupById, 
        dataGroupId, 
        categoryIds,
        operatorId,
        companyId, 
        subCompanyId, 
        siteId,
        daysOfWeek
    ) => {
        const response = await axios.post(`Analysis/Export`, {
            emailAddress,
            fromDate,
            toDate,
            dataType,
            totalBy,
            timeGroupById,
            dataGroupId,
            categoryIds,
            operatorId,
            companyId: companyId || -1, 
            subCompanyId: subCompanyId || -1,
            siteId: siteId || -1,
            daysOfWeek
        });
        return response.data;
    }

}

export default new Analysis();